export default "__VITE_ASSET__9vR7PQ7P__"